export default {
	 compareRoles (allowedRoles, userRoles) {
		let match = false;

		allowedRoles.forEach((allowedRole) => {
			userRoles.forEach((userRole) => {
				if (userRole === allowedRole) match = true;
			});
		});

		return match;
	}
};



// WEBPACK FOOTER //
// ./src/services/Permissions.js